import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query'

export function pickEditor(
  field: string,
): 'string' | 'number' | 'boolean' | 'date' {
  const numericHints = [
    'port',
    'id',
    'event_id',
    'process_id',
    'parent_process_id',
    'dest_port',
    'src_port',
  ]
  return numericHints.some((h) => field.toLowerCase().includes(h))
    ? 'number'
    : 'string'
}

/**
 * Prune a CompositeFilterDescriptor to only include predicates whose fields
 * are in the allowed set for the selected tool. Groups with no children are removed;
 * single-child groups are collapsed for tidier output.
 */
export function pruneForTool(
  v: CompositeFilterDescriptor,
  allowed: Set<string>,
): CompositeFilterDescriptor {
  const out: CompositeFilterDescriptor = { logic: v.logic, filters: [] }
  for (const f of v.filters) {
    if ((f as CompositeFilterDescriptor).filters) {
      const child = pruneForTool(f as CompositeFilterDescriptor, allowed)
      if (child.filters.length) out.filters.push(child)
    } else {
      const fd = f as FilterDescriptor
      if (fd.field && allowed.has(String(fd.field))) out.filters.push(fd)
    }
  }
  // Collapse nested single-group to keep the tree neat
  if (
    out.filters.length === 1 &&
    (out.filters[0] as CompositeFilterDescriptor).filters
  ) {
    return out.filters[0] as CompositeFilterDescriptor
  }
  return out
}
